<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('bankProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('bankProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            <img
              class="ts-rounded ts-h-24 ts-w-24"
              v-lazy="{
                src: record.bank_logo,
                error: require('@/assets/upload.png'),
                loading: require('@/assets/Rolling-1s-200px.svg'),
                preLoad: 1.3,
                attempt: 1
              }"
            />
          </td>
          <td>{{ record.bank_name }}</td>
          <td class="ts-space-x-3">
            <template v-for="(a, index) in record.accounts">
              <div
                :key="index"
                class="ts-border ts-float-left ts-p-2 ts-rounded"
                style="width: fit-content"
              >
                <p class="ts-mb-0" v-if="a.prefix">
                  <span>Prefix: </span>
                  <span
                    class="ts-text-green-500 ts-font-extrabold ts-tracking-wider"
                    >{{ a.prefix }}</span
                  >
                </p>
                <p class="ts-mb-0">
                  <span>Account Number: </span>
                  <span
                    class="ts-text-blue-600 ts-font-extrabold ts-tracking-wider"
                    >{{ a.account_number }}</span
                  >
                </p>
                <p class="ts-mb-0">
                  <span>Account Name: </span>
                  <span class="ts-text-yellow-700">{{ a.account_name }}</span>
                </p>
              </div>
            </template>
          </td>
          <td>{{ record.description }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('bankProfile.pageTitle')"
        centered
        @cancel="clearEdit"
        :maskClosable="false"
        :zIndex="1020"
        :footer="null"
        width="650px"
      >
        <from-action @cancel="clearEdit" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'bankProfile',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('corporate/bankProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.corporate.bankProfile.search
      },
      set (newValue) {
        this.$store.commit('corporate/bankProfile/SET_SEARCH', newValue)
        this.$store.commit('corporate/bankProfile/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('bankProfile.logo') },
        { name: this.$t('bankProfile.bankName') },
        { name: this.$t('bankProfile.accountNumber') },
        { name: this.$t('bankProfile.description') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('corporate/bankProfile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('corporate/bankProfile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('corporate/bankProfile/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('corporate/bankProfile/destroy', record.bank_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('corporate/bankProfile/RESET_STATE')
    next()
  }
}
</script>
